import React from 'react'
import './skills.css'
import Python from './python.png'
import C from './c.png'
import Java from './java.png'
import HTML from './html.png'
import CSS from './css.png'
import Leadership from './leadership.png'
import AWS from './2560px-AmazonWebservices_Logo.svg.png'
import Azure from './Microsoft_Azure_Logo.svg.png'

const Skills = () => {
  return (
    <section class="skills" id="skills">
      <h2>MY SKILLS</h2>
      <div id="container">
        <div class="skillbox">
          <img src={Python} alt="Python" />
          <p>
            I know the basics of Python Programming Language and its libraries.
          </p>
        </div>
        <div class="skillbox">
          <img src={C} alt="C" />
          <p>
            I know the basics of C programming language and has a good command on it.
          </p>
        </div>
        <div class="skillbox">
          <img src={Java} alt="C" />
          <p>
            I know the basics of Java programming language and currently enhacing it.
          </p>
        </div>
        <div class="skillbox">
          <img src={HTML} alt="C" />
          <p>
            Currently learning HTML for Website development and know the basic syntaxes.
          </p>
        </div>
        <div class="skillbox">
          <img src={CSS} alt="C" />
          <p>
            Currently learning CSS for Website development and know the basic syntaxes.
          </p>
        </div>
        <div class="skillbox">
          <img src={Leadership} alt="Web-Dev" />
          <p>
            Enhanced my Leadership qualities since I was chosen the Group leader during my Internship.
          </p>
        </div>
        <div class="skillbox">
          <img src={AWS} alt="Web-Dev" />
          <p>
            Over a year of hands-on experience in cloud computing, having deployed numerous projects on the AWS Cloud platform.          </p>
        </div>
        <div class="skillbox">
          <img src={Azure} alt="Web-Dev" />
          <p>
            Acquainted with Azure Functions and various other services within the Azure Cloud.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Skills